import {
  Avatar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
import moment from "moment";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { formattedDate, formattedTime } from "../../utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function DashboardTable({
  headerData,
  tableData,
  diplayRows,
  showHeader,
}) {
  const { t } = useTranslation(["dashboard", "common"]);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.currentLanguage
  );

  return (
    <TableContainer sx={{ marginTop: "12px" }}>
      <Table
        // sx={{
        //   minWidth: minWidth ? minWidth : 1000,
        // }}
        size="small"
        stickyHeader
      >
        <TableHead sx={{ display: showHeader ? "table-header-group" : "none" }}>
          <TableRow>
            {headerData?.map((column, _index) => (
              <TableCell
                key={_index}
                align={column.align}
                style={{
                  //   minWidth: column.minWidth,
                  color: appcolors.black,
                  fontWeight: "500",
                  fontSize: 14,
                  fontFamily: "Poppins",
                }}
              >
                <Typography>{t(column.label)}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData
            //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            ?.map((row, ind) => {
              return (
                <TableRow key={ind}>
                  {diplayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val == "date_and_month" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography
                                fontSize={"1rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {moment(row?.createdAt).format("DD")}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {moment(row?.createdAt).format("MMM")}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "company_detail" ? (
                          <TableCell>
                            <Typography variant="body1" fontWeight={600}>
                              {row.name || row.businessName}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Email:{row.email || row.businessEmail}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              {t("contact", { ns: "common" })}:{row.contact}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              {t("location", { ns: "common" })}:{row.location?.addressLabel}
                            </Typography>
                          </TableCell>
                        ) : val == "worker_detail" ? (
                          <TableCell>
                            <Typography variant="body1" fontWeight={600}>
                              {row.name || row.businessName}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Email:{row.email || row.businessEmail}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              {t("contact", { ns: "common" })}:{row.contact}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              {t("location", { ns: "common" })}:{row.location?.addressLabel}
                            </Typography>
                          </TableCell>
                        ) : val == "client_detail" ? (
                          <TableCell>
                            <Typography variant="body1" fontWeight={600}>
                              {`${row.firstname} ${row.lastname}`}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Email:{row.email}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              {t("contact", { ns: "common" })}:{row.contact}
                            </Typography>
                          </TableCell>
                        ) : val == "worker_new_appointement_detail" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography variant="body2">
                                {moment(row.createdAt).format(
                                  "ddd,DD MMM YYYY hh:mm a"
                                )}
                                <span
                                  style={{
                                    color: "lightgreen",
                                    marginLeft: 10,
                                  }}
                                >
                                  {t("after20Min", { ns: "common" })}
                                </span>
                              </Typography>
                              <Typography variant="body1" fontWeight={500}>
                                {row.name}
                              </Typography>
                              <Typography variant="body2">
                                {t("address")} : {row.address}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "worker_appointment_price" ? (
                          <TableCell padding="normal">
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={0.5}
                            >
                              <Typography variant="body2">
                                {row.price} {t("perHr", { ns: "common" })}{" "}
                                <span style={{ fontWeight: 500 }}>USD</span>
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "ownerData" ? (
                          <TableCell padding="normal">
                            <Stack>
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {row.name}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                              >
                                Email:{row.email}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("contact", { ns: "common" })}:{row.contact}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {t("location", { ns: "common" })}:{row.location}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "showDetailBtn" ? (
                          <TableCell padding="normal">
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              gap={2}
                              sx={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={600}
                                color={appcolors.black}
                              >
                                {t("details", { ns: "common" })}
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "booker_name" ? (
                          <TableCell padding="normal">
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {row.name}
                            </Typography>
                          </TableCell>
                        ) : val == "booked_service" ? (
                          <TableCell padding="normal">
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {row.service}
                            </Typography>
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={400}
                              color={
                                row.isDone
                                  ? appcolors.black
                                  : appcolors.slateGrey
                              }
                            >
                              {formattedDate(row.bookingDate, false)}
                            </Typography>
                          </TableCell>
                        ) : val == "booking_time" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={400}
                                  color={
                                    row.isDone
                                      ? appcolors.emeraldGreen
                                      : appcolors.indianRed
                                  }
                                >
                                  {formattedDate(row.createdAt, false)}
                                </Typography>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={400}
                                  color={
                                    row.isDone
                                      ? appcolors.emeraldGreen
                                      : appcolors.indianRed
                                  }
                                >
                                  {formattedTime(row.bookingDate, true)}
                                </Typography>
                              </Stack>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "activity_detail" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.gunmetal}
                                textTransform={"capitalize"}
                              >
                                {moment(row.createdAt).format(
                                  "DDD, DD/MM/YYYY h:mm a"
                                )}
                              </Typography>
                              <Typography
                                variant="body1"
                                fontSize={"0.75rem"}
                                color={appcolors.emeraldGreen}
                                textTransform={"uppercase"}
                              >
                                {row.status}
                              </Typography>
                            </Stack>
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row.service}
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              {row.location?.addressLabel}
                            </Typography>
                          </TableCell>
                        ) : val == "activity_price" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="h1"
                                fontSize={"0.875rem"}
                                fontWeight={500}
                              >
                                {`${row.price} USD`}
                              </Typography>
                              <ArrowRightAltIcon />
                            </Stack>
                          </TableCell>
                        ) : val == "product_detail" ? (
                          <TableCell padding="normal">
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar src={row.coverImage} />
                              <Typography>
                                {row.name[currentLanguage]}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "top_worker_detail" ? (
                          <TableCell padding="normal">
                            <Typography variant="body1" fontWeight={600}>
                              {row.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Email:{row.email}
                            </Typography>
                            {/* <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Contact:{row.contact}
                            </Typography>
                            <Typography
                              variant="body2"
                              color={appcolors.gunmetal}
                            >
                              Location:
                              {row.location}
                            </Typography> */}
                          </TableCell>
                        ) : val == "to_service_name" ? (
                          <TableCell>
                            {row.name[currentLanguage]}
                          </TableCell>
                        ) : (
                          <TableCell padding="normal">{row[val]}</TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
